import { Link } from "react-router-dom";
import "./SocialNetworkLink.scss";
import { SocialNetworkType } from "./ContactPageData";

const SocialNetworkLink = ({ label, link, icon }: SocialNetworkType) => {
  return (
    <Link
      target="_blank"
      rel="noopener noreferrer"
      to={link}
      className="Social-Network-Link"
    >
      <div className="Icon">{icon}</div>
      <label className="Label">{label}</label>
    </Link>
  );
};
export default SocialNetworkLink;
